import type { CascadeStopAt } from '@/types/pulse'

export const CASCADE_STOP_STAGES = ['text', 'screenplay', 'storyboard', 'image', 'audio', 'video'] as const satisfies readonly CascadeStopAt[]

const CASCADE_STAGE_LABEL_KEYS: Record<CascadeStopAt, string> = {
  text: 'station.text',
  screenplay: 'station.screenplay',
  storyboard: 'station.storyboard',
  image: 'station.image',
  audio: 'station.audio',
  video: 'station.video',
}

export function cascadeStopStageLabelKey(stopAt: CascadeStopAt): string {
  return CASCADE_STAGE_LABEL_KEYS[stopAt]
}
